import axiosInstance  from "services/axiosMiddleware";


export const completeRelaxation = async ({ studentId, courseId, relaxationId }) => {
  try {
    const response = await axiosInstance.post(
      '/relaxation/mark-complete',  
      {
        student_id: Number(studentId),
        course_id: Number(courseId),
        relaxation_id: Number(relaxationId),
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error marking relaxation as complete:', error);
    throw error.response?.data || error.message || 'Failed to complete relaxation';
  }
};


// Fetch all completions for a student in a course
export const fetchStudentCompletion = async ({ studentId, courseId }) => {
  try {
    const response = await axios.get(`/student_relaxation_completion?student_id=${studentId}&course_id=${courseId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching student completion:', error);
    throw error.response?.data || error.message || 'Failed to fetch completion';
  }
};
